import type { ReactNode } from 'react';

interface BaseProps {
  title: ReactNode;
  right?: ReactNode;
  compact?: boolean;
  className?: string;
  contentId?: string;
}

interface CollapsibleProps extends BaseProps {
  expanded: boolean;
  onToggle: () => void;
}

interface StaticProps extends BaseProps {
  expanded?: undefined;
  onToggle?: undefined;
}

type Props = CollapsibleProps | StaticProps;

export default function SectionHeader(props: Props) {
  const baseClass = props.compact
    ? 'ui-section-header--button ui-section-header--row py-1.5'
    : 'ui-section-header--button ui-section-header--row';

  if (props.onToggle) {
    return (
      <button
        type="button"
        onClick={props.onToggle}
        aria-expanded={props.expanded}
        aria-controls={props.contentId}
        className={`ui-section-header ui-section-header--button ${baseClass} ${props.className ?? ''}`.trim()}
      >
        <span className="flex items-center gap-2 min-w-0">
          <span className="text-muted" aria-hidden="true">
            {props.expanded ? '▾' : '▸'}
          </span>
          <span className="truncate">{props.title}</span>
        </span>
        <span className="ui-command-panel__actions text-xs normal-case tracking-normal font-normal">
          {props.right ?? (props.expanded ? 'collapse' : 'expand')}
        </span>
      </button>
    );
  }

  return (
    <div
      className={`ui-section-header ui-section-header--row ${props.compact ? 'py-1.5' : ''} ${props.className ?? ''}`.trim()}
    >
      <span className="min-w-0 truncate">{props.title}</span>
      {props.right && (
        <span className="ui-command-panel__actions text-xs normal-case tracking-normal font-normal">
          {props.right}
        </span>
      )}
    </div>
  );
}
